// extracted by mini-css-extract-plugin
module.exports = {"statistic":"index_statistic__bDJBN","chart":"index_chart__XUizO"};